import React, { PureComponent } from 'react';
import { withStyles } from "@mui/styles";
import {
  Grid,
  Typography,
  CircularProgress,
  Button,
  Input,
} from '@mui/material';
import PropTypes from 'prop-types';
import { size } from 'lodash';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { getUserIdToken, signInAnonymously } from '../utils/firebase';
import { calculateEndingSurvey } from '../utils/dates';
import config from '../config';
import { successMessage, errorMessage } from '../utils/message';

class SuggestionDetails extends PureComponent {
  state = {
    token: getUserIdToken(),
    suggestionIsSending: false,
    answer: null,
    dialogOpen: false,
  };

  componentDidMount() {
    const { state } = this;
    if (!state.token) {
      signInAnonymously((token) => {
        if (!state.token) {
          this.setState({ token });
        }
      });
    }
  }

  handleClose = () => {
    this.setState({ dialogOpen: false });
  };

  confirmSending = (id) => {
    this.setState({ dialogOpen: false });
    this.sendSuggestionResponse(id);
  };

  errorSending = () => {
    this.setState({ suggestionIsSending: false });
  };

  succesSending = () => {
    const { goToList } = this.props;
    this.setState({ suggestionIsSending: false, answer: null });
    if (goToList) {
      goToList();
    }
  };

  sendSuggestionResponse = (id) => {
    const { answer, token } = this.state;

    if (size(answer) < 10) {
      errorMessage('Votre réponse doit faire au moins 10 caractères');
      return;
    }

    if (!token) {
      errorMessage(
        'Impossible de vous identifier. Si le problème persiste, contactez le support IntraMuros (support@intramuros.org).',
      );
      return;
    }

    this.setState({ suggestionIsSending: true });
    const url = config.apiRoot + config.apiSuggestion;

    const data = new FormData();
    data.append('suggestbox', id);
    data.append('answer', answer || '');
    data.append('origin', 'widget');
    data.append('token', token || '');

    fetch(url, {
      method: 'POST',
      body: data,
    })
      .then((response) => {
        if (response.ok) {
          return response;
        }
        const error = new Error(response.statusText);
        error.response = response;
        return Promise.reject(error);
      })
      .then((r) => r.json())
      .then(() => {
        successMessage('Merci. Votre suggestion a été transmise.');
        this.succesSending();
      })
      .catch((error) => {
        this.errorSending();
        const response = error ? error.response : null;
        if (response && response.status) {
          if (response.status === 429) {
            errorMessage(
              'Vous avez atteint votre quota. Veuillez réessayer dans 1h.',
            );
          } else {
            errorMessage(
              'Erreur (code ' +
              response.status +
              " ) ! Veuillez essayer à nouveau. Si le problème persiste, vérifiez votre connexion internet ou contactez le support IntraMuros (support@intramuros.org) en précisant le code d'erreur.",
            );
          }
        } else {
          errorMessage(
            "Impossible d'envoyer votre réponse. Veuillez essayer à nouveau. Si le problème persiste, vérifiez votre connexion internet ou contactez le support IntraMuros (support@intramuros.org).",
          );
        }
      });
  };

  render() {
    const { classes, item, goToList } = this.props;
    const { answer, suggestionIsSending, dialogOpen } = this.state;

    if (!item) {
      return null;
    }

    return (
      <div
        style={{
          padding: 20,
          width: '100%',
        }}
      >
        <Button onClick={() => goToList()} variant="text">
          {'< Retour'}
        </Button>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          style={{
            backgroundColor: 'white',
            padding: 20,
          }}
        >
          <Grid item xs={10} sm={8} md={7} lg={6} style={{ width: '100%' }}>
            <Typography
              align="center"
              className={classes.titleText}
              variant="h5"
              component="h1"
            >
              {item.name}
            </Typography>

            {item.end_date ? (
              <Typography
                align="center"
                className={classes.endDateText}
                variant="subtitle2"
              >
                {'Fin de la participation '}
                {calculateEndingSurvey(item.end_date)}
              </Typography>
            ) : null}

            {item.description ? (
              <Typography
                align="left"
                className={classes.descriptionText}
                variant="body2"
              >
                {item.description}
              </Typography>
            ) : null}

            <Input
              placeholder="Décrivez-nous votre idée"
              style={{
                borderWidth: 1,
                borderColor: '#E9E9E9',
                flexWrap: 'wrap',
                padding: 10,
                width: '100%',
                textAlign: 'left',
                color: 'black',
                minHeight: 300,
              }}
              multiline
              rowsmax={15}
              onChange={(event) =>
                this.setState({ answer: event.target.value })
              }
              value={answer || ''}
            />

            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              spacing={0}
            >
              <Button
                onClick={() => {
                  if (size(answer) < 10) {
                    errorMessage(
                      'Votre réponse doit faire au moins 10 caractères',
                    );
                    return;
                  }
                  this.setState({ dialogOpen: true });
                }}
                variant="contained"
                style={{
                  marginTop: 10,
                  backgroundColor: '#1baae1',
                  color: 'white',
                  borderRadius: 0,
                }}
                disabled={suggestionIsSending}
              >
                {suggestionIsSending ? (
                  <CircularProgress style={{ width: 20, height: 20 }} />
                ) : (
                  <div>{'Envoyer'}</div>
                )}
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Dialog
          open={dialogOpen}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div style={{ backgroundColor: 'white' }}>
            <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
            <DialogContent>
              <DialogContentText
                id="alert-dialog-description"
                style={{ color: 'black' }}
              >
                {"Veuillez confirmer l'envoi de votre suggestion"}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Annuler
              </Button>
              <Button
                onClick={() => this.confirmSending(item.id)}
                color="primary"
                autoFocus
              >
                Envoyer
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      </div>
    );
  }
}

const styles = () => ({
  questionText: {
    marginTop: 20,
    marginBottom: 5,
    color: '#003057',
    fontWeight: 'bold',
  },
  titleText: {
    color: '#003057',
    fontWeight: 'bold',
  },
  endDateText: {
    color: '#868686',
    marginTop: 5,
  },
  descriptionText: {
    marginTop: 20,
    whiteSpace: 'pre-line',
  },
});

SuggestionDetails.propTypes = {
  classes: PropTypes.objectOf(PropTypes.object()).isRequired,
  item: PropTypes.objectOf(PropTypes.object()).isRequired,
  goToList: PropTypes.objectOf(PropTypes.object()).isRequired,
};

export default withStyles(styles)(SuggestionDetails);
